import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { NudgeConfig, NudgeResponse } from "src/app/shared/models/nudge.model";
import { NotificationService } from "../notification/notification.service";
import { UserDetailsService } from "../user-details.service";

@Injectable({
  providedIn: "root",
})
export class NudgeEngineService {
  private activeNudgesSubject = new BehaviorSubject<NudgeConfig[]>([]);
  activeNudges$ = this.activeNudgesSubject.asObservable();

  constructor(
    private notificationService: NotificationService,
    private userDetailsService: UserDetailsService
  ) {}

  async loadNextNudge(scope: string): Promise<NudgeResponse> {
    const companyId = await this.getResolvedCompanyId();
    if (!companyId) {
      this.activeNudgesSubject.next([]);
      return { nudge: null, nextEligibleAt: null };
    }

    const payload = {
      scope,
    };

    return new Promise(async (resolve) => {
      (await this.notificationService.getNextNudge(payload, companyId)).subscribe(
        (response: any) => {
          const nudgeResponse: NudgeResponse = response?.data || {
            nudge: null,
            nextEligibleAt: null,
          };
          const nudges = nudgeResponse?.nudge ? [nudgeResponse.nudge] : [];
          this.activeNudgesSubject.next(nudges);
          resolve(nudgeResponse);
        }
      );
    });
  }

  dismissNudge(id: string) {
    this.activeNudgesSubject.next(
      this.activeNudgesSubject.value.filter((nudge) => nudge.id !== id)
    );
  }

  getScopedNudges(scope: string): NudgeConfig[] {
    return this.activeNudgesSubject.value.filter((nudge) => nudge.scope === scope);
  }

  private async getResolvedCompanyId() {
    const selectedCompanyId = await this.userDetailsService.getSelectedCompanyId();
    if (selectedCompanyId) {
      return selectedCompanyId;
    }

    const companyId = await this.userDetailsService.getCompanyId();
    if (companyId) {
      return companyId;
    }

    const selectedCompanyData = (await this.userDetailsService.getSelectedCompanyData()) as
      | { id?: any; company_id?: any }
      | null;
    return selectedCompanyData?.id || selectedCompanyData?.company_id || null;
  }
}
